// extracted by mini-css-extract-plugin
module.exports = {"App":"DefaultPage_App__2Y4JL","AppLogo":"DefaultPage_AppLogo__1aVgs","AppHeader":"DefaultPage_AppHeader__3r1T3"};